import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { AboutPage } from '../../features/marketing/pages/AboutPage';

export const Route = createFileRoute('/$lang/about')({ component: Page });

function Page(): ReactNode {
  const { lang } = Route.useParams();
  return <AboutPage lang={lang} />;
}
